import { Component } from 'react';
import classNames from 'classnames';
import ThemeDefinition from '../../domain/ThemeDefinition';

import { Typography } from '@canvas-logic/clp-shared-ui';

import style from './CanvasLogicBranding.module.css';

interface IProps {
  url: string;
}

export class CanvasLogicBranding extends Component<IProps> {
  render() {
    return (
      <a
        className={classNames(style.root, ThemeDefinition.canvasLogicBranding)}
        target="_blank"
        href={this.props.url}
        rel="noreferrer"
      >
        <Typography variant="paragraph-sm" color="description" component="span">
          Powered by CanvasLogic
        </Typography>
      </a>
    );
  }
}
